module.exports = window["nab"]["utils"];